export const msConfig = {
  client: '',
  authority: '',
  redirecturi: ''
};